import React, { useEffect, useState } from "react";
import partnerWithAptechBanner from "../../assets/images/partnerWithAptechBanner.png";
import partnerWithAptechBannerTwo from "../../assets/images/partnerWithAptechBannerTwoNew.png";
import aptechOfferBanner from "../../assets/images/aptechOfferBanner.jpg";
import styles from "./PartnerWithAptech.module.scss";
import classNames from "classnames";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
// import nextArrow from "../../assets/images/nextArrow.png";
// import downArrow from "../../assets/images/downArrow.png";
// import returnArrow from "../../assets/images/returnArrow.png";
// import DownArrowInMobile from '../../assets/images/DownArrowInMobile.png'
import enquirySectionImg from '../../assets/images/enquirySectionImg.png'
import { motion } from "framer-motion";

const offerList = [
  "A proven and sustainable business model ",
  "Rights to use Aptech's registered trademarks and brand names for business",
  "Comprehensive training programs for a successful start of the business",
  "Complete support for centre promotion and marketing activities  ",
  "Continuous support to ensure smooth centre operations ",
  "State-of-the-art training tools and equipment ",
  "Strong brand recognition ",
  "Placement assistance to students ",
  "Provides access to up-to-date curriculum ",
  "Opportunity to grow and earn huge profits.  ",
];
const BenefitsList = [
  "Earn a high return on investment  ",
  "Grow business in the vocational training industry ",
  "Benefit from Aptech’s brand reputation ",
  "Access modern-day industry-driven curriculum ",
  "Connect with industry leaders and strengthen placement networks ",
  "Receive comprehensive training for smooth centre operation ",
];
const cardData = [
  "A suitable premises with potential for future expansion. ",
  "State-of-the-art classroom infrastructure.",
  "Computers and updated software for training purposes.",
  "Statutory license required to operate the centre."
];
const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Partner with Aptech", link: "" },
];
const PartnerWithAptech: React.FC = () => {
  const content = [
    `Aptech aims to expand its vocational skill training programs across multiple brands, creating new business partnership opportunities for those who want to invest in the education sector. It invites business partners to join its mission and contribute to empowering learners with industry-relevant skills while building a successful and impactful business. Together, we can shape a brighter future.`,
    `With over 840 Aptech centres across India and abroad, Aptech business partners ensure effective and seamless program delivery. They are dedicated to guiding and mentoring students, helping them develop themselves into skilled, industry-ready professionals.`,
  ];
  const [isMobile, setIsMobile] = useState<boolean>(false);
  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth < 768);
    };
    updateView();
    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);
  return (
    <div className={`${styles.PartnerWithAptech}`}>
      <BreadCrumb menu={breadcrumb} />
      <div className="container">
      <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <div className={classNames(styles.Banner, "row mt-5 pt-0")}>
          <div className="col-12">
            <ImageTextSection
              imageSrc={partnerWithAptechBanner}
              imageAlt="partnerWithAptechBanner Image"
              content={content}
              colImageValue={6}
              colTextValue={6}
              heading="Partner with Aptech"
              reverse={true}
              imageAlign="center"
              imageAlignInMob="center"
              imageHeightTablet={`25rem`}
            />
          </div>
        </div>
        </motion.div>
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
        <div className={`section row ${styles.bannerTwo}`}>
          <div className="col-lg-3 col-md-12 col-sm-12 d-flex justify-content-center">
            <div className={styles.image2}>
              <img
                src={partnerWithAptechBannerTwo}
                alt="partnerWithAptechBannerTwo"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-9 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
            <p className="para pt-3">
            Partnering with Aptech is more than just a business opportunity. It is a chance for business partners to join a trusted education brand and make a meaningful impact on the lives of students and professionals, while earning high returns on investment. 
            </p>
          </div>
        </div>
        </motion.div>
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >

        <div className="section">
          <div className={`row ${styles.partnerSection}`}>
            <div className="col-12">
              <div className={`row ${styles.IndustrialSectionDiv}`}>
                <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-center position-relative">
                  <div className={styles.innerDiv}>
                    <p className="heading">
                      What Aptech Offers to its Business Partners 
                    </p>
                    <p className="para">
                    Aptech provides <strong>business partnership opportunities</strong> that empower entrepreneurs to thrive in the vocational training industry. It offers the following benefits to empower its business partners in the vocational training business:
                    </p>
                    <ul className={`para ${styles.listItem}`}>
                      {offerList.map((content, index) => (
                        <li key={index}>
                          <span className={`para ${styles.listItem}`}>
                            {content}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className={styles.borderSection} />
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-end align-items-end">
                  <img
                    src={aptechOfferBanner}
                    alt="aptechOfferBannerImage"
                    className={`img-fluid ${styles.IndustrialImage}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </motion.div>

        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >

        {!isMobile && (
          <div className={`section ${styles.centresSetSection}`}>
            <div className={`row ${styles.titleDiv}`}>
            <div className="col-12">
                <p className="heading text-center">
                  To set up a centre, a prospective partner should provide"
                </p>
              </div>
              </div>

{/* <div className="col-3">
                <div style={{border:'1px solid #DB6516',padding:'20px',borderRadius:'20px'}}>
                  <div className="d-flex justify-content-center align-items-center" style={{width:'20px',padding:'20px',backgroundColor:'white',height:'20px',borderRadius:'50px',border:'1px solid #E1C78C'}}>
                 <p className="para mb-0"> 1</p>
                 </div>
                  <p className="para pt-2">A suitable premises with potential for future expansion. </p>
                </div>

              </div>
              <div className="col-3">
                <div style={{border:'1px solid #DB6516',padding:'20px',borderRadius:'20px'}}>
                  <div className="d-flex justify-content-center align-items-center" style={{width:'20px',padding:'20px',backgroundColor:'white',height:'20px',borderRadius:'50px',border:'1px solid #E1C78C'}}>
                 <p className="para mb-0"> 1</p>
                 </div>
                  <p className="para pt-2">A suitable premises with potential for future expansion. </p>
                </div>

              </div>
              <div className="col-3">
                <div style={{border:'1px solid #DB6516',padding:'20px',borderRadius:'20px'}}>
                  <div className="d-flex justify-content-center align-items-center" style={{width:'20px',padding:'20px',backgroundColor:'white',height:'20px',borderRadius:'50px',border:'1px solid #E1C78C'}}>
                 <p className="para mb-0"> 1</p>
                 </div>
                  <p className="para pt-2">A suitable premises with potential for future expansion. </p>
                </div>

              </div>
              <div className="col-3">
                <div style={{border:'1px solid #DB6516',padding:'20px',borderRadius:'20px'}}>
                  <div className="d-flex justify-content-center align-items-center" style={{width:'20px',padding:'20px',backgroundColor:'white',height:'20px',borderRadius:'50px',border:'1px solid #E1C78C'}}>
                 <p className="para mb-0"> 1</p>
                 </div>
                  <p className="para pt-2">A suitable premises with potential for future expansion. </p>
                </div>

              </div> */}
            <div className={`row ${styles.rowContainer}`}>
  {/* Dashed lines between cards */}
  {[1, 2, 3].map((_, i) => (
    <div
      key={i}
      className={styles.dashedLine}
      style={{
        left: `calc(${(i + 1) * 25}% + ${(i === 0) ? '0px' : (i === 2 ? '-3px' : '0px')})`
      }}
    />
  ))}

  {cardData.map((text, idx) => (
    <div className={`col-md-3 d-flex ${styles.cardCol}`} key={idx}>
  <div className={`${styles.cardBox} w-100`}>
    <div className={styles.circle}>
      <p className="para mb-0">{idx + 1}</p>
    </div>
    <p className="para pt-2 text-left">{text}</p>
  </div>
</div>

  ))}
</div>

            {/* </div> */}
           
          </div>
        )}
        </motion.div>
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >

        {isMobile && (
          <div className={`section ${styles.centresSetSection}`}>
            <div className={`row`}>
              <div className="col-12">
                <p className="heading text-center">
                  To set up a centre, a prospective partner should provide 
                </p>
              </div>
            </div>
            <div className={`row ${styles.rowContainer}`}>
  {/* Dashed lines between cards */}
  {[1, 2, 3].map((_, i) => (
    <div
      key={i}
      className={styles.dashedLine}
      style={{
        left: `calc(${(i + 1) * 25}% + ${(i === 0) ? '0px' : (i === 2 ? '-3px' : '0px')})`
      }}
    />
  ))}

{cardData.map((text, idx) => (
  <div className={`col-12 col-md-3 position-relative ${styles.cardCol}`} key={idx}>
    <div className={`${styles.cardBox} w-100`}>
      <div className={styles.circle}>
        <p className="para mb-0">{idx + 1}</p>
      </div>
      <p className="para pt-2 text-left">{text}</p>
    </div>
  </div>
))}



</div>

          </div>
        )}
        </motion.div>
        <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >

        <div className={classNames(styles.benefits, "section")}>
          <h2 className="heading">Benefits of partnering with Aptech </h2>
          <p className="para">
            Partnering with Aptech provides business partners with the
            opportunity to:
          </p>
          <div className="row">
            {BenefitsList.map((benefit, index) => (
              <div
                key={index}
                className={classNames("col-lg-4 col-md-6 col-sm-6")}
              >
                <div className={styles.benefit}>
                  <div className="para caps">{benefit}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        </motion.div>

       
      </div>
      <div className="container-fluid">
      <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
      <div className={styles.enquirySection}>
          <div className="row g-0">
            <div className="col-lg-8 col-md-12 col-sm-12 d-flex flex-column justify-content-center">
              <p className={`para pb-0`}>
              To partner with us and enter into a profitable business opportunity in the education sector, send in your details here 
              </p>
              <a href="mailto:enquiry@aptech.co.in" className={`${styles.link} para pt-0`}>
              <strong>enquiry@aptech.co.in</strong>
                    </a>

            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-center">
            <img
                src={enquirySectionImg}
                alt="enquirySectionImg"
                className={`${styles.enquirySectionImg} img-fluid`}
              />

            </div>

          </div>

        </div>
        </motion.div>

      </div>

    </div>
  );
};

export default PartnerWithAptech;
